import mapColourTheme from "./mapColourTheme"

export const mapOptions = {
	backgroundColor: '#f1f1f1',
	clickableIcons: false,
	disableDefaultUi: false,
	fullscreenControl: false,
	mapTypeControl: false,
	maxZoom: 11,
	minZoom: 2,
	rotateControl: false,
	scaleControl: false,
	scrollwheel: false,
	streetViewControl: false,
	styles: mapColourTheme,
	zoomControl: true,
	zoomControlOptions: {
		position: 4
	},
}
